import { Directive, HostListener, Output, EventEmitter, HostBinding, ElementRef } from '@angular/core';
import swal from 'sweetalert2';

@Directive({
  selector: '[appFileExtValidator]'
})
export class FileExtValidatorDirective {

  @Output()
  fileChange = new EventEmitter();

  constructor(
    private _elementRef: ElementRef
  ) { }

  @HostListener('change', ['$event'])
  onChange(event) {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const acceptedExtensions = this._elementRef.nativeElement.accept;
      if (acceptedExtensions.includes(file.name.split('.').slice(-1)[0])) {
        this.fileChange.emit(event);
      } else {
        swal('Warning', 'File type not allowed', 'warning');
      }
    }
  }

}



// WEBPACK FOOTER //
// G:/UTL/BMI/Admin/Admin-ANG/src/app/shared/directives/file-ext-validator.directive.ts